/** IANA zone from the browser (e.g. America/New_York); falls back to UTC. */
export function getBrowserIanaTimeZone(): string {
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return typeof tz === "string" && tz.length > 0 ? tz : "UTC";
    } catch {
        return "UTC";
    }
}
